import { Control, useWatch } from 'react-hook-form';

import { AllEnums, EnumListKey } from '~/data/enums';
import {
  getCountryByLegalEntity,
  useAllLegalEntities,
} from '~/data/legalEntity';
import { filterActiveEnumsByCountryAndOrgUnits } from '~/utils/helper';

import { Form } from './useRehireEmpForm';

export const useRehireEnumFilteredOptions = (
  control: Control<Form>,
  allEnums: AllEnums,
  enumType: EnumListKey,
) => {
  const fEmpLegalEntityValue = useWatch({
    control,
    name: `rehire.empPosition.fEmpLegalEntity`,
  });

  const fEmpOrgUnitValue = useWatch({
    control,
    name: `rehire.empPosition.fInternalPositionUnit`,
  });

  const { legalEntities } = useAllLegalEntities();

  return filterActiveEnumsByCountryAndOrgUnits(
    allEnums[enumType],
    getCountryByLegalEntity(+fEmpLegalEntityValue, legalEntities),
    fEmpOrgUnitValue,
  );
};
